import { useEffect, useState } from "react"
import bg from "assets/images/pleasure/bg.svg"
import star from "assets/images/pleasure/star.svg"
import logo from "assets/images/pleasure/logo.svg"
import title from "assets/images/pleasure/title-en.svg"
import titleFr from "assets/images/pleasure/title-fr.svg"
import horse from "assets/images/pleasure/horse.svg"
import arrow from "assets/images/pleasure/arrow.svg"
import button from "assets/images/pleasure/button.svg"
import icon from "assets/images/pleasure/icon.png"
import { FormattedMessage } from "react-intl"
import { sendAmplitudeEvent } from "lib/amplitude"
import { trackMetaEvent } from "lib/meta"
import { trackSnapchatClick } from "lib/snapchat"
import { sendGoogleClickConversion } from "lib/google"
import { generateAppsFlyerLink } from "lib/common"
import { twMerge } from "tailwind-merge"
import { ReactComponent as Spinner } from "assets/images/spinner-s.svg"

type Props = {
  locale: string
}

const SURVEY_ID = "pleasure"

export function PleasurePage(props: Props) {
  const [angle, setAngle] = useState(0)
  const [isPressed, setIsPressed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const onButtonClick = () => {
    if (isLoading) return

    setIsLoading(true)

    let redirected = false

    const redirect = () => {
      if (redirected) return
      redirected = true
      location.assign(generateAppsFlyerLink(SURVEY_ID))
    }

    const timeoutId = window.setTimeout(() => {
      redirect()
    }, 3000)

    try {
      trackMetaEvent("Lead")
      trackSnapchatClick()

      sendGoogleClickConversion(() =>
        sendAmplitudeEvent(
          "onboarding_cta_clicked",
          {
            onboarding: SURVEY_ID,
          },
          () => {
            clearTimeout(timeoutId)
            redirect()
          },
        ),
      )
    } catch (e) {
      clearTimeout(timeoutId)
      redirect()
    }
  }

  useEffect(() => {
    const id = window.setInterval(() => {
      setAngle((prev) => (prev + 60) % 360)
    }, 1000)

    return () => window.clearInterval(id)
  }, [])

  useEffect(() => {
    sendAmplitudeEvent("onboarding_started", {
      onboarding: "pleasure",
    })
  }, [])

  return (
    <div
      className="relative w-full h-full max-h-dvh overflow-x-hidden overflow-y-auto bg-no-repeat bg-[length:100%_100%] bg-[#BDAEF7] desktop:flex desktop:items-center desktop:justify-center"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <img
          src={star}
          alt=""
          className="absolute left-[45%] top-1/3 desktop:top-1/2 -translate-x-1/2 -translate-y-1/2 w-[140dvh] h-[140dvh] max-w-none origin-[52%_58%] desktop:min-w-[1024px] desktop:min-h-[1024px]"
          style={{ transform: `translate(-50%, -50%) rotate(${angle}deg)` }}
        />
      </div>
      <div className="absolute top-0 left-0 right-0 pt-[38px] desktop:pt-[68px] px-[28px] desktop:px-[38px] flex desktop:justify-end justify-start">
        <img
          src={logo}
          alt="PURE Dating App"
          className="h-[79px] desktop:h-auto"
        />
      </div>
      <div className="max-h-dvh h-full desktop:h-auto justify-center relative z-10 w-full px-5 py-6 flex flex-col desktop:flex-row desktop:justify-center max-w-[450px] desktop:max-w-none mx-auto">
        <div className="self-end">
          <img
            src={props.locale === "fr" ? titleFr : title}
            alt="Pleasure is Power"
            className="h-[100px] desktop:h-auto height-650-desktop:h-[180px]"
          />
        </div>
        <div className="shrink desktop:-ml-[160px] desktop:mt-[80px] desktop:-mr-[60px] height-700-desktop:-ml-[80px] height-700-desktop:-mr-5 self-center desktop:self-start">
          <img
            src={horse}
            alt=""
            className="max-h-[320px] height-650:max-h-[220px] desktop:!max-h-[80dvh]"
          />
        </div>
        <div className="desktop:self-start self-center -mr-10 desktop:-mr-0 -mt-[60px] desktop:-mt-0">
          <img
            src={arrow}
            alt=""
            className="desktop:-translate-x-[65%] -translate-x-1/2 -rotate-[14deg] h-[100px] desktop:h-auto"
          />
          <div
            className={twMerge(
              "hover:scale-105 transition-all duration-[50ms]",
              isPressed && "!scale-[0.98]",
              !isLoading && "cursor-pointer",
            )}
            onClick={onButtonClick}
            onPointerDown={() => !isLoading && setIsPressed(true)}
            onPointerUp={() => setIsPressed(false)}
            onPointerLeave={() => setIsPressed(false)}
            onPointerCancel={() => setIsPressed(false)}
          >
            <img
              src={icon}
              alt="Pure"
              width={154}
              height={154}
              className="-rotate-[4deg] max-w-[130px] desktop:max-w-none"
            />
            <button
              className={twMerge(
                " -rotate-[10deg] -mt-5 -ml-4 bg-[length:100%_100%] bg-no-repeat h-[58px] desktop:h-[69px] px-[18px] flex items-center justify-center text-white outline-none border-none uppercase font-sans-bold text-[24px] desktop:text-[28px] leading-[32px] relative transition-transform duration-100",
                props.locale === "fr" && "-ml-9",
              )}
              style={{ backgroundImage: `url(${button})` }}
              disabled={isLoading}
            >
              <span className={twMerge(isLoading && "opacity-0")}>
                <FormattedMessage id="button.download" />
              </span>

              {isLoading && (
                <span className="absolute inset-0 flex items-center justify-center">
                  <Spinner className="animate-spin" />
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
